<!-- 巡检路线选择弹窗 -->
<template>
  <el-dialog
    title="选择巡检路线"
    :visible.sync="dialogVisible"
    width="1200px"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="route-select-container">
      <avue-crud
        ref="crud"
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :search.sync="query"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @row-dblclick="handleRowDblClick"
        @selection-change="handleSelectionChange"
      >
        <!-- 自定义操作列 -->
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            size="small"
            @click="handleSelect(row)"
          >
            选择
          </el-button>
        </template>
      </avue-crud>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :disabled="!selectedRow" @click="handleConfirm">
        确认选择
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getList } from "../../InspectionRouteManage/api";

export default {
  name: "RouteSelectDialog",
  mixins: [crudMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiConfig: { getList },
      selectedRow: null,
      option: {
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        searchMenuSpan: 6,
        selection: true,
        menuWidth: 100,
        column: [
          {
            label: "路线编号",
            prop: "routeCode",
            overHidden: true,
            search: true,
            searchPlaceholder: "请输入路线编号",
            searchSpan: 6,
          },
          {
            label: "路线名称",
            prop: "routeName",
            overHidden: true,
            search: true,
            searchPlaceholder: "请输入路线名称",
            searchSpan: 6,
          },
          {
            label: "点位数量",
            prop: "pointCount",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.pointCount || 0;
            },
          },
          {
            label: "预计耗时",
            prop: "estimatedTime",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.estimatedTime ? `${row.estimatedTime}分钟` : "-";
            },
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 80,
            showColumn: false,
            dataType: "string",
            dicData: [
              { label: "全部状态", value: "" },
              { label: "启用", value: "1" },
              { label: "禁用", value: "0" },
            ],
            formatter: (row) => {
              return row.status === 1 ? "启用" : "禁用";
            },
          },
          {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            overHidden: true,
            search: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.onLoad(this.page);
      }
    },
  },
  methods: {
    // 选择路线
    handleSelect(row) {
      this.selectedRow = row;
      this.$emit("select", row);
      this.dialogVisible = false;
    },

    // 确认选择
    handleConfirm() {
      if (this.selectedRow) {
        this.$emit("select", this.selectedRow);
        this.dialogVisible = false;
      } else {
        this.$message.warning("请选择一条路线");
      }
    },

    // 行选择变化
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.selectedRow = selection[0];
      }
    },

    // 双击行
    handleRowDblClick(row) {
      this.handleSelect(row);
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.selectedRow = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.route-select-container {
  ::v-deep .avue-crud__search {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  }

  ::v-deep .avue-crud__table {
    .el-table__header th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
    .el-table__row:hover {
      background-color: #f5f7fa;
    }
  }

  ::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
  }

  ::v-deep .el-button--text {
    padding: 0 8px;
    margin-right: 0;
    &:hover {
      color: #409eff;
    }
  }
}
::v-deep .avue-crud__menu {
  display: none !important;
}
.dialog-footer {
  text-align: right;
}
</style>
